import axios from 'axios';
import { getPurchaseDetailsRequestBody, getPurchaseMailData, getQuoteResponse } from '../../../selectors/sizotsaFuneralCover/quote';
import { setSizotsaApiDetails, setSizotsaApplicationApiStatus, setPurchaseServiceResponse } from '../../../actions/sizotsaFuneralCover/referenceData';
import { API_CALL_STATUS } from '../../../reducers/status';
import { sendEmailNotification, sendEmailNotificationWithAttachments } from './leadsMailService';
import { getPersonalDetailsSummary, getPurchasePersonalDetailsForm } from '../../../selectors/sizotsaFuneralCover/personalDetails';
import { navigateNext, navigateToThankYou } from '../../../actions/sizotsaFuneralCover/routing';
import httpStatusCode from '../../../../api-server/constants/httpStatusCode';
import { getPurchaseResponse } from '../../../selectors/sizotsaFuneralCover/referenceData';
import { getDocumentsArray } from '../../../selectors/sizotsaFuneralCover/uploadDocuments';

export const purchaseService = (store, next, action) => {
    const state=store.getState();
     const purchaseResponse =  getPurchaseResponse(state);
    const documents=getDocumentsArray(state)
    const {firstName,surname,mobileNumber, email}=getPurchasePersonalDetailsForm(state)
    const{funeralPremium}= getQuoteResponse(state)
    const purchaseMailPayload=getPurchaseMailData(state)

    const sendPurchaseEmailOnSuccess = async (policyNumber) => {
        try {
        const formData = new FormData();
        Object.values(documents)?.map(doc =>doc?.file && formData.append('files', doc.file));

        const requestBody = {
            firstName: firstName.value,
            lastName: surname.value,
            contactNumber: mobileNumber.value,
            subject: `Web: Sizotsa funeral: ${policyNumber}`,
            userDataFields: purchaseMailPayload,
            templateType: 'SZ_FUNERAL_PURCHASE_BUSINESS',
            monthlyPremium: funeralPremium,
            yearlyPremium: (funeralPremium * 12 ?? 0).toFixed(2),
            referenceNumber: null,
            email: 'SIZOSTA_FUNERAL_BUSSINESS_MAIL'
        };
        formData.append('data', JSON.stringify(requestBody));
        await sendEmailNotificationWithAttachments(formData);
         } catch (error) {
            console.log(error);
            
        }
    };

    const sendPurchaseEmailOnSuccessCustomer= async ( policyNumber ) => {
        const requestBody = {
            firstName:firstName.value,
            lastName:surname.value,
            contactNumber:mobileNumber.value,
            subject:`Web: Sizotsa funeral: ${policyNumber}`,
            userDataFields: [{
                fullName:firstName.value + ' ' + surname.value,
                policyName:"Sizosta Funeral Purchase",
                referenceNumber:policyNumber,
                premium: funeralPremium
            }],
            templateType:"SZ_FUNERAL_PURCHASE_CUSTOMER",
            monthlyPremium:  funeralPremium,
            yearlyPremium: (funeralPremium*12??0).toFixed(2),
            referenceNumber: null,
            email: email.value
        }
         await sendEmailNotification(requestBody);
    }
    

    

    (async () => {
        try{
            store.dispatch(setSizotsaApiDetails({status:API_CALL_STATUS.PENDING,name:'purchaseService'}));
            const sampleRequestBody= getPurchaseDetailsRequestBody(state)
            const response = await sendPurchaseDetails(sampleRequestBody);
        if (response && response.status === httpStatusCode.OK) {
            // store.dispatch(setAllsureApplicationQuoteDetails(response.data));
            store.dispatch(setPurchaseServiceResponse(response?.data))
            store.dispatch(setSizotsaApiDetails({status:API_CALL_STATUS.SUCCESS,name:'purchaseService'}));
            await sendPurchaseEmailOnSuccess(response?.data?.id);
            await sendPurchaseEmailOnSuccessCustomer(response?.data?.id);
            store.dispatch(navigateToThankYou())
        } else {
            // store.dispatch(navigateToThankYou())            
            store.dispatch(setSizotsaApiDetails({status:API_CALL_STATUS.FAILURE,name:'purchaseService',content:response?.response?.data?.data?.message??null}));
        }
    }
        catch(error){
            console.log(error)
            // store.dispatch(navigateToThankYou())
            store.dispatch(setSizotsaApiDetails({status:API_CALL_STATUS.FAILURE,name:'purchaseService',content:error?.data?.message??null}));
        }
    })();
    return next(action);
};

const sendPurchaseDetails = async (requestBody)=>{
        try {
            // /om-api/ka-metlha-funeral/sendPurchaseDetails
            const response = await axios({
                url: '/om-api/sizotsa-funeral/purchase',
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Access-Control-Allow-Origin': '*',
                },
                data: requestBody,
            });
            return response;
        } catch (error) {
            return error;
        }
}

